import { ActionStatus, depascalize } from "sprint-common-web";

import { FileRecordStatus } from "../../../../../common/types/FileRecordStatus";
import { FileRecordListingItem } from "../../types/FileRecordListingItem";

export interface RemoveFileRecordItem {
    id: string;
    deliveryFileName: string;
    content: string;
    status: string;
    originalStatus: FileRecordStatus;
    filePath?: string;
    isNotificationApproved: boolean;
}

export type ProcessRemoveFileRecordItem = RemoveFileRecordItem & {
    processStatus: ActionStatus;
};

export const mapToRemoveFileRecordItem = (item: FileRecordListingItem): RemoveFileRecordItem => {
    return {
        id: item.id,
        deliveryFileName: item.deliveryFileName,
        content: item.content ?? "-",
        status: depascalize(FileRecordStatus[item.status]),
        originalStatus: item.status,
        isNotificationApproved: item.isNotificationApproved,
        filePath: item.filePath
    };
};
